import loadable from '@loadable/component';
import type * as ModerationReportModalModule from './ModerationReportModal';

export const LoadableModerationReportModal = loadable(() => import('./ModerationReportModal'), {
  resolveComponent: (module: typeof ModerationReportModalModule) => module.ModerationReportModal,
  fallback: null
});
